/* eslint-disable import/prefer-default-export */
import { createStructuredSelector } from 'reselect'
import { hasSubscriptionSelector } from 'reduxModules/app/selectors'

const imagesModal = state => state.merchs.imagesModal
const modalIsOpen = state => state.merchs.modalIsOpen

const merchsSelector = state =>
  state.merchs.list.map(merch => ({
    ...merch,
    photo: { original: merch.photo.original },
    previewPhoto: { large: merch.previewPhoto.large }
  }))

export default createStructuredSelector({
  merchs: merchsSelector,
  imagesModal,
  modalIsOpen,
  isSubscribed: hasSubscriptionSelector
})
